<script setup lang="ts">
import { computed } from 'vue'
import { format } from 'date-fns'
import { type Check } from '../types'
import { useCheckStore } from '../stores/check-store'
import StatusBadge from './StatusBadge.vue'

const props = defineProps<{
  check: Check
}>()

const store = useCheckStore()

const bgGradient = computed(() => {
  return props.check?.status === 'false_positive'
    ? 'bg-gradient-to-r from-[#3982AF] to-[#408F92]'
    : 'bg-gradient-to-r from-red-700 to-red-800'
})

const message = computed(() => {
  return props.check?.status === 'false_positive' ? 'dismissed as a false positive' : 'confirmed as a match'
})

const reviewedAt = computed(() => format(new Date(props.check?.reviewed_at), 'yyyy/MM/dd'))
</script>

<template>
  <div class="rounded-lg p-3 text-sm text-white" :class="bgGradient">
    <div class="flex items-center justify-between">
      <p class="opacity-80">AML Screening Check</p>
      <span class="inline-block rounded-md bg-white">
        <StatusBadge :status="check?.status" />
      </span>
    </div>
    <div class="mt-2">
      <span class="font-semibold">{{ store.searchParams(check)?.name }}</span> search results were {{ message }} on
      <span class="font-semibold">{{ reviewedAt }}</span> by
      <span class="font-semibold">{{ check?.reviewed_by?.name }}</span
      >.
    </div>
    <div class="mt-2 opacity-80" v-if="check?.note"><span class="font-medium">Note:</span> {{ check?.note }}</div>
  </div>
</template>
